import { Archivo, Big_Shoulders, JetBrains_Mono } from "next/font/google";
import type { ReactNode } from "react";
import "./tokens.css";

const display = Big_Shoulders({
  subsets: ["latin"],
  weight: ["800", "900"],
  variable: "--font-sm-display",
  // Brand face must actually load — optional+no-preload left enter/marketing on system fallbacks
  display: "swap",
  adjustFontFallback: true,
  preload: true,
});

const archivo = Archivo({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  variable: "--font-sm-archivo",
  display: "swap",
  adjustFontFallback: true,
  preload: true,
});

const mono = JetBrains_Mono({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
  variable: "--font-sm-mono",
  display: "swap",
  adjustFontFallback: true,
  preload: false,
});

export function ScaffopsMarketingShell({ children }: { children: ReactNode }) {
  return (
    <div
      className={`scaffops-marketing sm-grid-bg min-h-screen ${display.variable} ${archivo.variable} ${mono.variable}`}
    >
      {children}
    </div>
  );
}

export function CautionTape({ size = "md" }: { size?: "md" | "lg" }) {
  return (
    <div
      className={size === "lg" ? "sm-caution-lg" : "sm-caution"}
      role="presentation"
      aria-hidden
    />
  );
}

export function ScaffopsButton({
  href,
  children,
  variant = "primary",
  external,
  className = "",
}: {
  href: string;
  children: ReactNode;
  variant?: "primary" | "secondary" | "ghost";
  external?: boolean;
  className?: string;
}) {
  const base =
    "inline-flex items-center justify-center px-5 py-3 text-sm font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--sm-charcoal)] disabled:opacity-50";
  const styles =
    variant === "primary"
      ? "bg-[var(--sm-yellow)] text-[var(--sm-charcoal)] hover:brightness-95"
      : variant === "secondary"
        ? "border border-[var(--sm-charcoal)] bg-[var(--sm-offwhite)] text-[var(--sm-charcoal)] hover:bg-white"
        : "border border-white/40 bg-transparent text-white hover:bg-white/10";

  const props = external
    ? { target: "_blank" as const, rel: "noopener noreferrer" }
    : {};

  return (
    <a href={href} className={`${base} ${styles} ${className}`} {...props}>
      {children}
    </a>
  );
}
